import React, { useState } from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./Stepssection.css";
import mascotLaptop from "/public/SiteImages/personaje-registrandose.svg";

function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="#009CFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4.2" />
      <path d="M4.5 20.5c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5" />
    </svg>
  );
}

function HomeIcon() {
  return (
    <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="#009CFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 10.5L12 3l9 7.5V20a1.5 1.5 0 0 1-1.5 1.5H4.5A1.5 1.5 0 0 1 3 20V10.5z" />
      <path d="M9.5 21.5V14.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v7" />
    </svg>
  );
}

function CalendarIcon() {
  return (
    <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="#009CFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4.5" width="18" height="16.5" rx="2.5" />
      <line x1="8" y1="2" x2="8" y2="5" />
      <line x1="16" y1="2" x2="16" y2="5" />
      <line x1="3" y1="9.5" x2="21" y2="9.5" />
      <circle cx="7.5" cy="13.5" r="1" fill="#009CFF" />
      <circle cx="12" cy="13.5" r="1" fill="#009CFF" />
      <circle cx="16.5" cy="13.5" r="1" fill="#009CFF" />
      <circle cx="7.5" cy="17" r="1" fill="#009CFF" />
      <circle cx="12" cy="17" r="1" fill="#009CFF" />
      <circle cx="16.5" cy="17" r="1" fill="#009CFF" />
    </svg>
  );
}

const CITIES = [
  { value: "santacruz", label: "Santa Cruz" },
  { value: "lapaz", label: "La Paz" },
  { value: "cochabamba", label: "Cochabamba" },
  { value: "tarija", label: "Tarija" },
  { value: "sucre", label: "Sucre" },
  { value: "samaipata", label: "Samaipata" },
  { value: "copacabana", label: "Copacabana" },
  { value: "uyuni", label: "Uyuni" },
];

function StepsSection() {
  const [city, setCity] = useState("santacruz");
  const [pricePerNight, setPricePerNight] = useState(250);
  const [nightsPerMonth, setNightsPerMonth] = useState(15);

  const handlePriceChange = (delta) => {
    setPricePerNight((prev) => Math.max(50, Math.min(5000, prev + delta)));
  };

  const handleNightsChange = (delta) => {
    setNightsPerMonth((prev) => Math.max(1, Math.min(30, prev + delta)));
  };

  const totalEarnings = pricePerNight * nightsPerMonth;
  const formattedEarnings = totalEarnings.toLocaleString("es-BO");

  return (
    <section className={s["eh-split-section"]}>
      <div className={s["eh-split-section__container"]}>
        {/* Left Column: Steps */}
        <div className={s["eh-steps-card"]}>
          <h2 className={s["eh-steps-card__heading"]}>Así de fácil es publicar</h2>

          <div className={s["eh-steps-list"]}>
            {/* Step 1 */}
            <div className={s["eh-step-item"]}>
              <div className={s["eh-step-item__icon-wrapper"]}>
                <UserIcon />
              </div>
              <div className={s["eh-step-item__content"]}>
                <div className={s["eh-step-item__header"]}>
                  <span className={s["eh-step-item__number"]}>1</span>
                  <h3 className={s["eh-step-item__title"]}>Crea tu cuenta</h3>
                </div>
                <p className={s["eh-step-item__desc"]}>
                  Regístrate gratis y verifica tu identidad en minutos.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className={s["eh-step-item"]}>
              <div className={s["eh-step-item__icon-wrapper"]}>
                <HomeIcon />
              </div>
              <div className={s["eh-step-item__content"]}>
                <div className={s["eh-step-item__header"]}>
                  <span className={s["eh-step-item__number"]}>2</span>
                  <h3 className={s["eh-step-item__title"]}>Publica tu propiedad</h3>
                </div>
                <p className={s["eh-step-item__desc"]}>
                  Agrega fotos, descripción, precio y disponibilidad. Nosotros te guiaremos en cada paso.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className={s["eh-step-item"]}>
              <div className={s["eh-step-item__icon-wrapper"]}>
                <CalendarIcon />
              </div>
              <div className={s["eh-step-item__content"]}>
                <div className={s["eh-step-item__header"]}>
                  <span className={s["eh-step-item__number"]}>3</span>
                  <h3 className={s["eh-step-item__title"]}>Recibe reservas y pagos</h3>
                </div>
                <p className={s["eh-step-item__desc"]}>
                  Todo el dinero llega directo a tu cuenta. Claro, seguro y sin vueltas.
                </p>
              </div>
            </div>
          </div>

          {/* Mascot in bottom left */}
          <div className={s["eh-steps-card__mascot"]}>
            <img src={mascotLaptop} alt="Publicar es fácil" className={s["eh-steps-card__mascot-img"]} />
          </div>
        </div>

        {/* Right Column: Calculator */}
        <div className={s["eh-calc-card"]}>
          <h2 className={s["eh-calc-card__heading"]}>¿Cuánto podrías ganar?</h2>

          <div className={s["eh-calc-form"]}>
            {/* Field 1: City */}
            <div className={s["eh-calc-field"]}>
              <label htmlFor="calc-city" className={s["eh-calc-label"]}>
                Ciudad
              </label>
              <div className={s["eh-select-wrapper"]}>
                <select
                  id="calc-city"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  className={s["eh-select"]}
                >
                  {CITIES.map((c) => (
                    <option key={c.value} value={c.value}>
                      {c.label}
                    </option>
                  ))}
                </select>
                <div className={s["eh-select-arrow"]}>
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#003453" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Field 2: Price per night */}
            <div className={s["eh-calc-field"]}>
              <label className={s["eh-calc-label"]}>
                Precio promedio por noche
              </label>
              <div className={s["eh-stepper"]}>
                <div className={s["eh-stepper__value"]}>
                  Bs {pricePerNight}
                </div>
                <div className={s["eh-stepper__controls"]}>
                  <button
                    type="button"
                    onClick={() => handlePriceChange(-25)}
                    className={s["eh-stepper__btn"]}
                    aria-label="Disminuir precio"
                  >
                    −
                  </button>
                  <button
                    type="button"
                    onClick={() => handlePriceChange(25)}
                    className={s["eh-stepper__btn"]}
                    aria-label="Aumentar precio"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>

            {/* Field 3: Nights per month */}
            <div className={s["eh-calc-field"]}>
              <div className={s["eh-stepper"]}>
                <div className={s["eh-stepper__value"]}>
                  {nightsPerMonth} {nightsPerMonth === 1 ? 'noche' : 'noches'}
                </div>
                <div className={s["eh-stepper__controls"]}>
                  <button
                    type="button"
                    onClick={() => handleNightsChange(-1)}
                    className={s["eh-stepper__btn"]}
                    aria-label="Disminuir noches"
                  >
                    −
                  </button>
                  <button
                    type="button"
                    onClick={() => handleNightsChange(1)}
                    className={s["eh-stepper__btn"]}
                    aria-label="Aumentar noches"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>

            {/* Result Box */}
            <div className={s["eh-calc-result"]}>
              <div className={s["eh-calc-result__label"]}>
                Ingresos estimados al mes
              </div>
              <div className={s["eh-calc-result__amount"]}>
                Bs {formattedEarnings}
              </div>
            </div>

            <p className={s["eh-calc-disclaimer"]}>
              *Este cálculo es referencial. Tus ingresos pueden variar.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default withStyles(s)(StepsSection);

